import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import "./styles.css";

// Индикатор загрузки для блоков, которые грузятся САМИ, вне общего конвейера.
//
// Двух штатных индикаторов панели тут не хватает: LinearProgress в шапке (state.app.isLoad,
// его ставит contentProvider на карточках) и LinearProgress в списках (ListProvider). Оба
// относятся к «главным» данным страницы, а блоки вроде истории скриптов ноды, каталога APK в
// модалке или списка ролей грузятся отдельным запросом — и до этого делали это молча: пустое
// место, неотличимое от «данных нет».
//
// text=null — только кружок (для тесных мест: строка таблицы, угол модалки).
export default function Loader({ text = 'Загрузка…', className = '', size = 20 }) {
    return <div className={`loader ${className}`} role="status">
        <CircularProgress size={size} thickness={4.5} className="loader__spinner"/>
        {text === null ? null : <span className="loader__text">{text}</span>}
    </div>;
}
